import React from 'react';

import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { fromCircle } from 'ol/geom/Polygon';
import { useDispatch, useSelector } from 'react-redux';

import ArrowBack from 'components/common/components/ArrowBack';
import PopupLoader from 'components/common/PopupLoader';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import { addAlert } from 'store/actions/alert/alerts';
import { authPatchRequestWithParam } from 'helpers/apiRequests';
import { formStyles } from 'consts/styles/Form';
import { updateJurysdiction } from 'components/map/mapUtils';
import { validateCheck } from '../components/Helpers';

import OrganizationsFormRender from '../components/OrganizationsFormRender/OrganizationsFormRender';

const EditOrganization = props => {
  const { organization, arrowBackClick } = props;
  const [seeableLoader, setSeeableLoader] = React.useState(false);
  const map = useSelector(state => state.map);

  const formClasses = formStyles();

  const dispatch = useDispatch();

  const useString = () => {
    const language = useSelector(state => state.language);
    return language;
  };
  const strings = useString().adminZone.editOrganization;
  const [alertsSubtitles] = React.useState(useString().alerts);
  const [values, setValues] = React.useState({
    name: organization.name,
    phone: organization.phone,
    city: organization.address.city,
    street: organization.address.street,
    number: organization.address.number,
    geojson: organization.geojson,
    parent: organization.parent,
    master: organization.master,
    email: organization.email,
    uid: organization.uid,
    buffer: organization.buffer,
  });

  const [errors, setErrors] = React.useState({
    map: false,
    name: false,
    phone: false,
    email: false,
    nip: false,
    regon: false,
    buffer: false,
  });

  const [displayErrors, setDisplayErrors] = React.useState(false);

  const handleChange = event => {
    const { target } = event;
    const { name, value } = target;

    const ifCheckIsTrue = validateCheck(name, value);

    setValues({
      ...values,
      [name]: value,
    });

    setErrors({ ...errors, [name]: !ifCheckIsTrue });
  };

  const onGeometryChange = value => {
    setValues({
      ...values,
      geojson: value,
    });
  };

  const checkData = () => {
    let isValid = true;
    Object.keys(values).forEach(key => {
      if (values[key] === '') isValid = false;
    });
    if (!isValid) setDisplayErrors(true);

    return isValid;
  };

  const add = async () => {
    if (!checkData()) return;

    setSeeableLoader(true);
    const data = { ...values };
    data.address = {
      city: values.city,
      street: values.street,
      number: values.number,
    };

    delete data.city;
    delete data.street;
    delete data.number;

    // if circle was drawn its geometry is sending to service to map it to polygon

    if (values?.geojson?.type === 'GeometryCollection') {
      const polygon = fromCircle(values.geojson.getGeometry(), 16);

      data.geojson = {
        type: 'Polygon',
        coordinates: polygon
          .transform('EPSG:3857', 'EPSG:4326')
          .getCoordinates(),
      };
    } else data.geojson = values.geojson;

    if (data.geojson === null) {
      dispatch(
        addAlert({
          title: alertsSubtitles[2].title_,
          desc: alertsSubtitles[2].desc_,
          type: 'error',
        })
      );
      setErrors({ ...errors, map: true });
    }
    const result = await authPatchRequestWithParam(
      'organization',
      data.uid,
      data
    );
    if (result.status === 200) {
      dispatch(
        addAlert({
          title: alertsSubtitles.addDataSuccess.title_,
          desc: alertsSubtitles.addDataSuccess.desc_,
          type: 'success',
        })
      );
      handleJurisdictionChange(result.data);
      setSeeableLoader(false);
      arrowBackClick();
    } else
      dispatch(
        addAlert({
          title: alertsSubtitles[result.data.code].title_,
          desc: alertsSubtitles[result.data.code].desc_,
          type: 'error',
        })
      );
    setSeeableLoader(false);
  };

  const handleJurisdictionChange = data => {
    if (data.geojson_buffer) {
      UserSessionDataHandler.saveToUserSettingsObjectInStorage(
        UserSessionDataHandler.defaultJurisdictionWithBuffer,
        data.geojson_buffer
      );

      updateJurysdiction(map);
    }

    if (data.buffer) {
      UserSessionDataHandler.saveToUserSettingsObjectInStorage(
        UserSessionDataHandler.defaultBuffer,
        data.buffer
      );
    }
  };

  return (
    <>
      {seeableLoader && <PopupLoader />}
      <div
        className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center ${formClasses.Form}__text-field`}
      >
        <ArrowBack clickFunction={arrowBackClick} fromLeft={0} />
        <Typography
          variant="h3"
          className={`${formClasses.Form}__text-field__title`}
        >
          {strings.header_}
        </Typography>
      </div>
      <div
        className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center ${formClasses.Form}__text-field`}
      >
        <Typography variant="h4">
          {strings.selectedOrgTitle_}: <b>{organization.name}</b>
        </Typography>
      </div>
      <OrganizationsFormRender
        add={add}
        handleChange={handleChange}
        onGeometryChange={onGeometryChange}
        drawnGeometry={values.geojson}
        values={values}
        displayErrors={displayErrors}
        buttonText={useString().adminZone.addOrganization.formFields.button_}
        strings={useString().adminZone.editOrganization}
        newOrganization={false}
        errors={errors}
        setErrors={setErrors}
      />
    </>
  );
};

EditOrganization.propTypes = {
  organization: PropTypes.object.isRequired,
  arrowBackClick: PropTypes.func.isRequired,
};

export default EditOrganization;
